export default "__VITE_ASSET__d042c2cb__"